module.exports = __webpack_public_path__ + "img/Cook-Islands.f53217d9.gif";